import { render, staticRenderFns } from "./LibrarySelect.vue?vue&type=template&id=65d48062&scoped=true"
import script from "./LibrarySelect.vue?vue&type=script&lang=js"
export * from "./LibrarySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d48062",
  null
  
)

export default component.exports